import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function ReactToastifyProvider({ children }) {
  return (
    <>
      {children}
      <ToastContainer
        position='top-right'
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </>
  );
}
